// UI texts: the Trader, Tobias (krug 5, K11)
export default {
  title: 'Trader',
  tagline: 'Fair prices. Mostly.',
  /** Package 4, part 0 (owner): Tobias's lines, one a day on his screen. */
  lines: [
    'Prices went up. Reason: the end of the world.',
    "I don't sell hope. Hope doesn't keep.",
    'Fair prices. Mostly.',
    'I used to collect tolls on Route 9. Now I collect interest.',
    "Don't tell the Tollmen you saw me. I owe them a truck.",
    "That's not haggling. That's begging. I accept both.",
    'Everything has a price. I just remember them.',
  ],
  back: 'Back to camp',
  newIn: 'New offers in {t}',
  refreshFree: 'New offers · Free',
  refreshNone: 'New offers tomorrow',
  refreshAllBought: 'Everything here is bought. New offers come tomorrow.',
  refreshed: 'New offers are in',
  tabs: { offers: 'Offers', sell: 'Sell' },
  left: '{n} left',
  buy: 'Buy',
  trade: 'Trade',
  sold: 'Sold',
  bought: 'Bought: {what}',
  /** 28. 10. 2026 (player report): a Blueprint offer's line, in its own rarity (the card said "an Epic recipe" for every one). */
  blueprint: 'Teaches one {rarity} Workshop recipe: you craft it on your tier.',
  traded: 'Traded: {give} → {get}',
  gearArrived: '{name} is in your Storage',
  /** "30 Chemicals → 12 Metal" */
  exchange: '{give} → {get}',
  swap: 'A straight swap',
  kind: { consumable: 'Supplies', exchange: 'Exchange', gear: 'Gear', rare: 'Rare find' },
  vsWorn: 'vs worn',
  nothingWorn: 'Nothing worn there',
  priceAria: 'Price: {list}',
  empty: 'Come back tomorrow',
  emptyBody: 'Tobias is out of stock. New offers in {t}.',
  locked: 'The Trader sets up at your camp at level {n}.',
  sell: {
    today: 'Today: {used} / {limit} Scrap',
    note: 'Tobias pays Scrap for resources, up to a daily limit.',
    have: '{n} in Storage',
    spare: '{n} spare',
    /** 9. 10. 2026 (owner): what the next runs take is never offered for sale; why, by what it is for. */
    keeps: 'Keeps {n} {name} for {what}',
    keepRuns: '{list} on your next {runs} runs',
    keepGenerator: 'the generator for {runs} days',
    keepAnd: ' and ',
    keepFor: {
      firearm: 'your firearm',
      chainsaw: 'the Chainsaw',
      truck: 'the truck',
      meal: 'your meals',
      bandage: 'Bandages',
      medkit: 'Medkits',
      repair: 'Repair kits',
    },
    line: 'Sell {qty} {name} → {scrap} Scrap',
    sell: 'Sell',
    overLimit: "Over today's limit",
    tooLittle: 'Too little for any Scrap',
    done: 'Sold {qty} {name} for {scrap} Scrap',
    none: 'Nothing to sell',
    noneBody: 'Resources in your Storage show up here.',
    discard: 'Discard instead',
    discardNote: 'Discarding gives nothing back.',
    less: 'Less {name}',
    more: 'More {name}',
    qty: 'Amount of {name}',
  },
  /** The Camp card. */
  card: {
    open: '{n} offers',
    openOne: '1 offer',
    none: 'All bought',
    aria: 'Trader, {name}: {n} offers not bought yet. New offers in {t}.',
    /** 29. 9. 2026: before level 3, one row in the card's place. */
    locked: 'Trader · Opens at level {n}',
    lockedTip: 'Tobias sells supplies, swaps your surplus for what your buildings need, and buys resources for Scrap. He arrives at level {n}.',
  },
  /** Under a building's cost, next to a red chip (K11.5). */
  link: 'Trade at {name}: {give} → {get}',
} as const;
